export const getItemValue = (item, config) => {
  switch (item.key) {
    case 'Parent First Name':
    case 'Parent Last Name':
      if (
        typeof config.ParentName === 'string' &&
        config.ParentName.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Address 1':
    case 'Address 2':
    case 'Address 3':
    case 'City':
    case 'State':
    case 'Zip Code':
      if (
        typeof config.Address === 'string' &&
        config.Address.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Language Id':
      if (
        typeof config.Language === 'string' &&
        config.Language.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Date of Birth':
      if (
        typeof config.Birthdate === 'string' &&
        config.Birthdate.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Parent Phone Number':
      if (
        typeof config.ParentPhoneNumber === 'string' &&
        config.ParentPhoneNumber.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Parent Email':
      if (
        typeof config.ParentEmail === 'string' &&
        config.ParentEmail.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'SSN':
      if (
        typeof config.SSN === 'string' &&
        config.SSN.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Teacher':
      if (
        typeof config.Teacher === 'string' &&
        config.Teacher.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Grade':
      if (
        typeof config.Grade === 'string' &&
        config.Grade.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Site':
      if (
        typeof config.Site === 'string' &&
        config.Site.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Student Last Name':
      if (
        typeof config.StudentLastName === 'string' &&
        config.StudentLastName.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Student First Name':
      if (
        typeof config.StudentFirstName === 'string' &&
        config.StudentFirstName.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Student Middle Name':
      if (
        typeof config.StudentMiddleName === 'string' &&
        config.StudentMiddleName.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Student Number':
      if (
        typeof config.StudentNumber === 'string' &&
        config.StudentNumber.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'School Info Ref Id':
      if (
        typeof config.SchoolInfoRefId === 'string' &&
        config.SchoolInfoRefId.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    case 'Student Info Ref Id':
      if (
        typeof config.StudentPersonalRefId === 'string' &&
        config.StudentPersonalRefId.toUpperCase() === 'SKIP'
      ) {
        return '(Skipped)';
      }
      break;
    default:
      break;
  }

  if (!item.value || item.value === '') {
    return '(No Data Available)';
  } else {
    return item.value;
  }
};



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/helpers/helper.js